/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./InfoDisclosure.vue?vue&type=template&id=62c96c70"
import script from "./InfoDisclosure.vue?vue&type=script&lang=js"
export * from "./InfoDisclosure.vue?vue&type=script&lang=js"
import style0 from "./InfoDisclosure.vue?vue&type=style&index=0&id=62c96c70&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports